import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Membership from "@/pages/Membership";
import OurCircles from "@/pages/OurCircles";
import VisitCircle from "@/pages/VisitCircle";
import Franchise from "@/pages/Franchise";
import Contact from "@/pages/Contact";
import Masterclass from "@/pages/Masterclass";
import RegionOwner from "@/pages/RegionOwner";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function Site({ children }) {
  return <Layout>{children}</Layout>;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Site><Home /></Site>} />
          <Route path="/about" element={<Site><About /></Site>} />
          <Route path="/membership" element={<Site><Membership /></Site>} />
          <Route path="/find-a-region" element={<Site><OurCircles /></Site>} />
          <Route path="/find-a-region/:slug" element={<Site><RegionOwner /></Site>} />
          <Route path="/our-circles" element={<Site><OurCircles /></Site>} />
          <Route path="/visit-a-circle" element={<Site><VisitCircle /></Site>} />
          <Route path="/franchise" element={<Site><Franchise /></Site>} />
          <Route path="/contact" element={<Site><Contact /></Site>} />
          <Route path="/masterclass" element={<Site><Masterclass /></Site>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
